import { render, staticRenderFns } from "./ContentListElement.vue?vue&type=template&id=545d13b2&scoped=true"
import script from "./ContentListElement.vue?vue&type=script&lang=js"
export * from "./ContentListElement.vue?vue&type=script&lang=js"
import style0 from "./ContentListElement.vue?vue&type=style&index=0&id=545d13b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545d13b2",
  null
  
)

export default component.exports